// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { auth } from './firebase'; // Import the auth object

ReactDOM.render(
  <React.StrictMode>
    <App auth={auth} /> {/* Pass the auth object as a prop */}
  </React.StrictMode>,
  document.getElementById('root')
);